export default {
  state: {
    apiData: {},
    apiDataPromise: {},
  },
  mutations: {
    SET_API_DATA(state, { endpoint, data }) {
      state.apiData[endpoint] = data;
    },
    SET_API_DATA_PROMISE(state, { endpoint, promise }) {
      state.apiDataPromise[endpoint] = promise;
    },
  },
  getters: {},
  actions: {
    loadApiData({ commit, dispatch, state }, endpoint) {
      if (state.apiDataPromise[endpoint]) {
        return state.apiDataPromise[endpoint];
      }

      const { customerSettings } = state;

      if (!customerSettings.letsbookApiId) {
        dispatch('logError', {
          code: 'editor-lets-integration',
          customer: state.customer,
          url: window?.location.href,
          idLets: customerSettings.letsbookApiId,
          endpoint,
        });
        const errorMsg =
          'A integração com o Motor Letsbook não está configurada.';
        console.warn(errorMsg);
        throw new Error(errorMsg);
      }

      const homolog = ['HOMO1', 'HOMO2', 'HOMO3'];
      const api = homolog.includes(customerSettings.letsbookApiId)
        ? 'https://desenv.letsbook.com.br/api/landing'
        : 'https://api.letsbook.com.br/landing';
      const url = `${api}/${endpoint}`;

      const promise = fetch(url)
        .then(async (res) => {
          if (res.status === 200) {
            let data = await res.json();

            if (Array.isArray(data)) {
              data = data.filter((item) => item); // remove nulls
            }

            commit('SET_API_DATA', {
              endpoint,
              data,
            });
          } else if (res.status === 404) {
            console.warn(res);
            throw res.status;
          } else {
            console.warn('Ops! Algo muito errado aconteceu.');
            throw res.status;
          }
        })
        .catch((reason) => {
          console.warn(reason);
          throw reason;
        });

      commit('SET_API_DATA_PROMISE', { endpoint, promise });

      return promise;
    },
  },
};
